import { Component } from '@angular/core';
import { CONFIGURATION } from '../app.config';
import { Router } from "@angular/router";
import { RouterModule, Routes } from '@angular/router';

declare var $: any;


@Component({
    moduleId: module.id,
    selector: 'app-sidenav',
    templateUrl: 'sidenav.html'
})
export class SideNavComponent {

    routerLinks:any = []

    userData: any;
    reportAccess: any = [];
    adminData: any = [];
    cg: any;
    allcg: any;
    showreport: boolean = false;
    roleflag: boolean = false;
    constructor(private router: Router) {
        this.userData = JSON.parse(localStorage.getItem('token'));
        this.adminData = this.userData.principal.roles;
        this.reportAccess = this.userData.principal.reportAccess;
        this.cg = this.userData.principal.controlGroups[0];
        this.allcg = this.userData.principal.controlGroups;
        this.adminData.forEach((element:any) => {
            if(element === 'User'){
                this.roleflag = true;
            }
        });
        if(this.roleflag = true){
        this.allcg.forEach((element:any) => {
            if(element === 'CRAZY LEGS PRODUCTIONS LLC'){
                this.showreport = true;
            }
        });
       }else{
        this.showreport = true;
       }
    }
    ngOnInit() {
        this.setRouterLinks()

        $('.panel-group').on('hidden.bs.collapse', this.toggleIcon);
        $('.panel-group').on('shown.bs.collapse', this.toggleIcon);

        $('body').bind('click', function (e: any) {
            if ($("#sidebar_left").css("position") == 'absolute' && !$(e.target).is('#sidebar_left_toggle')) {
                // click happened outside of .navbar, so hide
                var opened = $('.panel-collapse').hasClass('collapse in');
                if (opened === true && !document.getElementById('accordion').contains(e.target)) {
                    $('.panel-collapse').collapse('hide');
                }
            }
        });

        $(document).on('click', '.panel-collapse > li > a', function (e:any) {
            if ($("#sidebar_left").css("position") == 'absolute') {
                 if(e.target.parentNode.parentNode.parentNode.parentNode.id == 'reports'){
                    $("#reports-tap").trigger("click");
                }else if(!$(e.target).is('sidebar-title')){
                    $('.panel-collapse').collapse('hide');
                }
            }
        });

        $(document.body).on('click', ':not(.panel) > [data-toggle="collapse"][data-parent]', function() {
            var parent = $(this).data('parent');
            var target = $(this).data('target') || $(this).prop('hash');
            $(parent).find('.collapse.in').not(target).collapse('hide');
        });
        // if ($(window).width() < 1281) {
        //     $('body').removeClass('sb-r-o').addClass('mobile-view sb-l-m sb-r-c');
        //     $('.panel-collapse').collapse('hide');
        //  }
        $().ready(function() {
        if ($('body.sb-l-m').length){
            console.log('sb view')
            $('.panel-collapse').collapse('hide');
         }
        })
    }

    activeRoute(routename: string): boolean {
        return this.router.url.indexOf(routename) > -1;
    }
    gotoepcares() {
        this.router.navigate(['/reporting/epcares'])
    }

    toggleIcon(e: any) {
        $(e.target)
            .prev('.panel-heading')
            .find(".more-less")
            .toggleClass('fa-angle-right fa-angle-down');
    }

    setRouterLinks(){

        this.routerLinks.dashboard = {name:'Dashboard', link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.dashboard}`}
        this.routerLinks.invite = {name:'Invite User', link: `/${CONFIGURATION.reportingroute}/${CONFIGURATION.usermanagement}`,
        childLinks: [
            `/${CONFIGURATION.reportingroute}/inviteuser`,
            `/${CONFIGURATION.reportingroute}/inviteuser/update`
        ]
        }
        this.routerLinks.fileupload = {name:'File Manager', link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.fileupload}`}

        this.routerLinks.reports = {name:'Reports',
        submenu:{
            acaReports:{
                employeedetails:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.employeedetails}`},
                ercreport:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.ercreport}`},
                pdareport:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.pdareport}`},
                empnhreport:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.empnhreport}`},
                nftreport:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.nftreport}`},
                enftreport:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.enftreport}`},
                ogreport:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.ogreport}`},
                empstabilityperiod:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.empstabilityperiod}`},
                empbreakinservice:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.empbreakinservice}`},
                acaemploymentstatushistoryreport:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.acaemploymentstatushistoryreport}`},
            },
            otherReports:{
                shownames:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.shownames}`},
                empdemographics:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.empdemographics}`},
                payhistory:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.payhistory}`},
                benefitsenrollmentstatus:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.benefitsenrollmentstatus}`},
                termination:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.termination}`},
                Sick:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.Sick}`},
                report401k:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.report401k}`},
                report401kpayments:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.report401kpayments}`},
                verificationemployeedata:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.verificationemployeedata}`},
                epcares:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.epcares}`},
                monthlypaidemployees:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.monthlypaidemployees}`},
                orientationperiod:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.orientationperiod}`},
                sharpnewhire:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.sharpnewhire}`},
                currentlyemployed:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.currentlyemployed}`},
                dynamicReport:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.dynamicreport}`},
                dei:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.dei}`},
                detailpayrolledit:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.detailpayrolledit}`},
                bmpfulltimereport:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.bmpfulltimereport}`},
                employeeearningsummaryreport:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.employeeearningsummaryreport}`},
                customaggregatefringe:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.customaggregatefringe}`},
            },
            accountingReports:{
                costanalysisvendor:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.costanalysisvendor}`,
                childLinks:[
                    `/${CONFIGURATION.reportingroute}/vendordetail`,
                    `/${CONFIGURATION.reportingroute}/vendordetailall`
                ]},
                costanalysisshow:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.costanalysisshow}`, 
                childLinks: [
                    `/${CONFIGURATION.reportingroute}/shownamedetails`,
                    `/${CONFIGURATION.reportingroute}/shownamedetailsaccount`
                ]},
                costanalysisaccontnumber:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.costanalysisaccontnumber}`,
                childLinks: [
                    `/${CONFIGURATION.reportingroute}/accountdetaisl`
                ]},
                costanalysisirs1099:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.costanalysisirs1099}`,
                childLinks: [
                    `/${CONFIGURATION.reportingroute}/1099detail`
                ]},
                costanalysispayroll:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.costanalysispayroll}`,
                childLinks: [
                    `/${CONFIGURATION.reportingroute}/payrolldetail`
                ]},
                costanalysisdocnumber:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.costanalysisdocnumber}`,
                childLinks: [
                    `/${CONFIGURATION.reportingroute}/docnumberdetail`
                ]},
            },
            revUse:{
                invoicedetails:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.invoicedetails}`},
                datasheettracker:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.datasheettracker}`},
                newclients:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.newclients}`}
            },
            payDayReports:{
                federalpayday:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.federalpayday}`},
                statepayday:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.statepayday}`},
                annualaverage:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.annualaverage}`},
            },
            calSaverReports:{
                calsaver:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.calsaver}`},
                calsaversreport:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.calsaversreport}`},
            },
            granularlevelReports:{
                granularlevel:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.granularlevel}`},
            },
        }}

        this.routerLinks.management = {name:'1094C/1095C Management',
        submenu:{
            file1094:{link:`/${CONFIGURATION.reportingroute}/1094`, 
            childLinks:[
                `/${CONFIGURATION.reportingroute}/details1094`
            ]},
            file1095:{link:`/${CONFIGURATION.reportingroute}/1095`,
            childLinks:[
                `/${CONFIGURATION.reportingroute}/details1095`
            ]},
            clientOnboarding:{
                onboardingcustomerinformation:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.onboardingcustomerinformation}`},
                controlgroup:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.controlgroup}`},
                ale:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.ale}`},
                aledetails:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.aledetails}`},
            },
            irsManagement:{
                readytosubmitirs:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.readytosubmitirs}`},
                irsdatasubmittedstatus:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.irsdatasubmittedstatus}`},
                irsaudireport:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.irsaudireport}`},
                auditreport:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.auditreport}`},
            }
            }
        }

        // this.routerLinks.irsManagement = {name:'IRS Management',submenu:{
        //     readytosubmitirs:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.readytosubmitirs}`},
        //     irsdatasubmittedstatus:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.irsdatasubmittedstatus}`},
        //     irsaudireport:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.irsaudireport}`},
        //     auditreport:{link:`/${CONFIGURATION.reportingroute}/${CONFIGURATION.auditreport}`},
        // }}
    }

    displayActiveness(data:any, type = '', sublinks = ''){

        if(type == 'nested'){
            for (const key in this.routerLinks[sublinks].submenu[data]) {
                if(this.routerLinks[sublinks].submenu[data][key].link == this.router.url){
                    return 'activeSubMenu' 
                }else if(this.routerLinks[sublinks].submenu[data][key].childLinks){
                    if(this.routerLinks[sublinks].submenu[data][key].childLinks.includes(this.router.url)){
                        return 'activeSubMenu'
                    }
                }
            }
        }
        if(type == 'submenu'){
            for (const key in this.routerLinks[data].submenu) {
                for (const urllink in this.routerLinks[data].submenu[key]) {
                    if(this.routerLinks[data].submenu[key][urllink].link == this.router.url){
                        return 'activeSubMenu activePanelIcon';
                    }
                    else if(this.routerLinks[data].submenu[key][urllink].childLinks){
                        if(this.routerLinks[data].submenu[key][urllink].childLinks.includes(this.router.url)){
                            return 'activeSubMenu activePanelIcon' 
                        }
                    }
                }
            }
        }
        if(this.routerLinks[data] && this.routerLinks[data].link == this.router.url){
            return 'activePanelIcon'
        }
        else if(this.routerLinks[data] && !this.routerLinks[data].submenu && this.routerLinks[data].childLinks && (this.routerLinks[data].childLinks.some((childLink:any) => this.router.url.includes(childLink)))){
            return 'activePanelIcon'
        }
        else if( this.routerLinks[data] && this.routerLinks[data].submenu){
            for (const key in this.routerLinks[data].submenu) {
                if(this.routerLinks[data].submenu[key].link == this.router.url){
                    return 'activePanelIcon'  
                }else if(this.routerLinks[data].submenu[key].childLinks){
                    if(this.routerLinks[data].submenu[key].childLinks.some((childLink:any) => this.router.url.includes(childLink))){
                        return 'activePanelIcon' 
                    }
                }
            }
        }
    }

    getChildLinksActiveClass(data:any){
        if(data.childLinks.some((childLink:any) => this.router.url.includes(childLink)) || (data.link == this.router.url)){
            return 'active' 
        }else{
            return ''
        }
    }
    
    onClickSinglePanel(reportType = ''){
        if(reportType && reportType == 'management'){
            $('#onBoarding').collapse('hide');
            $('#irs-management').collapse('hide');

        }else{
            $('.panel-collapse').collapse('hide');
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/layout/sidenav.component.ts